// #region Imports

/* Telstream */
import {
  getDrives,
  getFilteredContents
} from '@/services/file-browser-service';
import {
  driveToFileEntryModel,
  entryToFileEntryModel
} from './utilities/file-utilities';
import {
  restoreFileBrowserFavorites,
  storefileBrowserFavorites
} from './utilities/persistence.utils';
import {
  SET_FILE_BROWSER_ENTRIES,
  SET_FILE_BROWSER_FAVORITES,
  SET_FILE_BROWSER_FILTER,
  SET_FILE_BROWSER_IS_BUSY,
  SET_FILE_BROWSER_ORDER,
  SET_FILE_BROWSER_PATH,
} from '@/utils/mutation-types';
import {
  FAVORITE_FOLDER,
  FILTER_FILES,
  LIST_FILES,
  ORDER_FILES,
  UNFAVORITE_FOLDER
} from '@/utils/action-types';

// #endregion Imports

export const files = {

  // #region State

  state: {

    path:      undefined,
    entries:   [],
    order:     'name',
    filter:    undefined,
    favorites: restoreFileBrowserFavorites(),
    isBusy:    false

  },

  // #endregion State

  // #region Mutations

  mutations: {

    [SET_FILE_BROWSER_ENTRIES](state, entries) {
      state.entries = entries;
    },

    [SET_FILE_BROWSER_FAVORITES](state, favorites) {
      state.favorites = favorites;
    },

    [SET_FILE_BROWSER_FILTER](state, filter) {
      state.filter = filter;
    },

    [SET_FILE_BROWSER_IS_BUSY](state, isBusy) {
      state.isBusy = isBusy;
    },

    [SET_FILE_BROWSER_ORDER](state, order) {
      state.order = order;
    },

    [SET_FILE_BROWSER_PATH](state, path) {
      state.path = path;
    }

  },

  // #endregion Mutations

  // #region Actions

  actions: {

    // #region File Browsing

    async [LIST_FILES](context, path) {
      if (!path) {
        context.commit(SET_FILE_BROWSER_IS_BUSY, true);

        const drives = await getDrives();
        context.commit(SET_FILE_BROWSER_ENTRIES, drives.map(driveToFileEntryModel));
        context.commit(SET_FILE_BROWSER_PATH, path);

        context.commit(SET_FILE_BROWSER_IS_BUSY, false);

        return;
      }

      let filter = context.state.filter;
      if (filter) {
        filter = `*${filter}*`;
      }

      context.commit(SET_FILE_BROWSER_IS_BUSY, true);

      const contents = await getFilteredContents(path, filter);
      if (contents.resultKind === 'Success') {
        context.commit(SET_FILE_BROWSER_ENTRIES, contents.entity.items.map(entryToFileEntryModel));
        context.commit(SET_FILE_BROWSER_PATH, path);
      }

      context.commit(SET_FILE_BROWSER_IS_BUSY, false);
    },

    // #endregion File Browsing

    // #region Filtering and Ordering

    [ORDER_FILES](context, order) {
      context.commit(SET_FILE_BROWSER_ORDER, order);
    },

    [FILTER_FILES](context, filter) {
      context.commit(SET_FILE_BROWSER_FILTER, filter);
      context.dispatch(LIST_FILES, context.state.path);
    },

    // #endregion Filtering and Ordering

    // #region Favorites

    [FAVORITE_FOLDER](context, path) {
      const favorites = restoreFileBrowserFavorites()
        .filter(f => f !== path);

      favorites.push(path);

      storefileBrowserFavorites(favorites);
      context.commit(SET_FILE_BROWSER_FAVORITES, favorites);
    },

    [UNFAVORITE_FOLDER](context, path) {
      const favorites = restoreFileBrowserFavorites()
        .filter(f => f !== path);

      storefileBrowserFavorites(favorites);
      context.commit(SET_FILE_BROWSER_FAVORITES, favorites);
    }

    // #endregion Favorites

  }

  // #endregion Actions

}